import { Box, SvgIconProps } from '@mui/material'
import { FC, useMemo } from 'react'
import { Icons } from 'utoniq-ui'

import { ItemType } from '@/clients/utoniq-core/schema'

type ItemIconProps = {
  type?: ItemType
  size?: 'xSmall' | 'small'
}

export const ItemIcon: FC<ItemIconProps> = ({
  type = ItemType.Image,
  size = 'xSmall',
}) => {
  const { width, height } = useMemo(() => {
    switch (size) {
      case 'small':
        return { width: 24, height: 24 }
      default:
        return { width: 16, height: 16 }
    }
  }, [size])

  return (
    <Box
      sx={{
        bgcolor: 'grey.50',
        borderRadius: '100%',
        width,
        height,
        p: 0,
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Icon iconType={type} sx={{ color: 'grey.700' }} fontSize={size} />
    </Box>
  )
}

const Icon = ({
  iconType,
  ...props
}: { iconType: ItemType } & SvgIconProps) => {
  switch (iconType) {
    case ItemType.Ticket:
      return <Icons.Ticket {...props} />
    case ItemType.Audio:
      return <Icons.Audio {...props} />
    case ItemType.Video:
      return <Icons.Video {...props} />
    case ItemType.Image:
      return <Icons.Image {...props} />
    case ItemType.Magazine:
      return <Icons.MagazineOn {...props} />
    case ItemType.Avatar:
      return <Icons.Avatar {...props} />
    case ItemType.Wallpaper:
      return <Icons.Wallpaper {...props} />
    case ItemType.Merch:
      return <Icons.Merch {...props} />
  }
}
